import Lenis from '@studio-freight/lenis';
import { variables } from './_variables.js';

let lenisInstance;



export const lenis = () => {
    if (lenisInstance) {
        lenisInstance.destroy();
    }

    lenisInstance = new Lenis({
        smooth: true,
        direction: 'vertical',
        gestureDirection: 'vertical',
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
    });

    function raf(time) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // スクロールイベントのリスナーを追加
    lenisInstance.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
        // 1画面分スクロールしたらヘッダーを固定
        const header = document.querySelector('.header');
        const windowHeight = window.innerHeight;
        if (scroll > windowHeight - 1) {
            header.classList.add('sticky');
        } else {
            header.classList.remove('sticky');
        }
    });

    // アンカーリンクの処理
    const anchors = document.querySelectorAll("a[href^='#']");
    const headerH = document.querySelector('.header')?.offsetHeight ?? 0;
    anchors.forEach(anchor => {
        anchor.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = anchor.getAttribute("href");
            const targetElement = targetId !== '#' ? document.querySelector(targetId) : null;
            if (targetElement) {
                lenisInstance.scrollTo(targetElement, {
                    offset: -headerH - 5,
                    duration: .9,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
                });
            }
        });
    });

    return lenisInstance;
};


// モバイルデバイスでスクロール制御を無効化するフラグ
export const mobileInvalid = true;

export const initScrollControl = (firstView, firstSection) => {
    
    // 必要な要素が存在しない場合は早期リターン
    if (!firstView || !firstSection) {
        console.warn('Required elements not found for scroll control');
        return null;
    }

    const { isMobile } = variables();

    // モバイルデバイスでmobileInvalidがtrueの場合は機能を無効化
    if (isMobile && mobileInvalid) {
        console.info('Scroll control disabled for mobile devices');
        return null;
    }

    // Lenisの初期化（共通設定）
    lenisInstance = new Lenis({
        smoothWheel: true,
        wheelMultiplier: 1,
        lerp: 0.1,
        duration: 1.2,  // スクロールアニメーションの時間を設定
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothTouch: isMobile, // モバイルの場合はタッチスクロールを有効化
        touchMultiplier: 2,
        infinite: false,
    });

    function raf(time) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    let isScrollingProgrammatically = false;
    let isInFirstViewSection = true;
    let scrollTimeout;

    // スクロール中のホイール操作とタッチ操作を無効化
    const wheelHandler = (e) => {
        if (isScrollingProgrammatically && isInFirstViewSection) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    document.addEventListener('wheel', wheelHandler, { passive: false });
    if (isMobile) {
        document.addEventListener('touchmove', wheelHandler, { passive: false });
    }

    // IntersectionObserver の設定
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.5, 1]
    };

    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (entry.target === firstView) {
                isInFirstViewSection = entry.isIntersecting;
            }

            if (!isScrollingProgrammatically && entry.isIntersecting && entry.intersectionRatio > 0.5) {
                clearTimeout(scrollTimeout);

                // firstViewが表示されている場合の下スクロール処理
                if (entry.target === firstView) {
                    lenisInstance.on('scroll', ({ scroll, direction }) => {
                        if (scroll < firstView.offsetHeight && direction === 1 && !isScrollingProgrammatically) {
                            isScrollingProgrammatically = true;
                            
                            lenisInstance.scrollTo(firstSection, {
                                duration: 1.2,
                                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                                lock: true,
                                onComplete: () => {
                                    scrollTimeout = setTimeout(() => {
                                        isScrollingProgrammatically = false;
                                        document.querySelector('.header').classList.add('sticky');
                                    }, 100);
                                }
                            });
                        }
                    });
                }
                
                // firstSectionが表示されている場合の上スクロール処理
                if (entry.target === firstSection) {
                    lenisInstance.on('scroll', ({ scroll, direction }) => {
                        // firstSectionの位置でスクロール位置を判定
                        const firstSectionTop = firstSection.offsetTop;
                        if (scroll <= firstSectionTop + 100 && direction === -1 && !isScrollingProgrammatically) {
                            isScrollingProgrammatically = true;
                            document.querySelector('.header').classList.remove('sticky');
                            lenisInstance.scrollTo(firstView, {
                                duration: 1.2,
                                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                                lock: true,
                                onComplete: () => {
                                    scrollTimeout = setTimeout(() => {
                                        isScrollingProgrammatically = false;
                                    }, 100);
                                }
                            });
                        }
                    });
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(firstView);
    observer.observe(firstSection);

    // クリーンアップ関数を返す
    return {
        toggleScrollUp: (enabled) => {
            isScrollUpEnabled = enabled;
            console.log(`Scroll up is now ${enabled ? 'enabled' : 'disabled'}`);
        },
        cleanup: () => {
            document.removeEventListener('wheel', wheelHandler);
            if (isMobile) {
                document.removeEventListener('touchmove', wheelHandler);
            }
            observer.disconnect();
            if (lenisInstance) {
                lenisInstance.destroy();
            }
        }
    };
};

// lenisInstanceをエクスポート
export { lenisInstance };